var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-application--wrap"},[_c('layoutToolbar',{attrs:{"full-toolbar":false}}),_c('layoutContent'),_c('layoutToTopFab')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }